import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-age-rating',
  styleUrls: ['./age-rating.component.scss'],
  template: `
    <div #wrapper class="absolute z-1" [ngClass]="wrapperDynamicClasses">
      <div class="age-rating border-round-lg p-x-2" [ngClass]="dynamicClasses">{{ rating }} +</div>
    </div>
  `,
  standalone: true,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgeRatingComponent implements AfterViewInit {
  @Input() wrapperDynamicClasses: { [key: string]: any };
  @Input() dynamicClasses: { [key: string]: any };
  @Input() rating: number | string;
  @Input() adjustPositions: { top: string; right: string; bottom: string; left: string };

  @ViewChild('wrapper', { static: false }) wrapper: ElementRef;

  ngAfterViewInit() {
    if (this.adjustPositions) {
      for (const key in this.adjustPositions) {
        this.wrapper.nativeElement.style[key] = this.adjustPositions[key];
      }
    }
  }
}
